<div class="row">
  <div class="col-sm-12 plan-container">
    <div>
      @if (userService.subDetails?.subscription) {
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <fui-heading [text]="env.studioOnePlusBrandName + ' Subscription' | translate" [level]="5"></fui-heading>
            @if (statusMap[userService.subDetails.subscription.status]) {
              <span class="pill m-l-10 gray" [class.green]="userService.subDetails.subscription.status == 'active'">
                {{ statusMap[userService.subDetails.subscription.status].title }}
              </span>
            }
          </div>
        </div>
      }

      @if (userService.subDetails?.subscription && userService.subDetails?.active) {
        <span class="bold d-block m-t-20">
          Plan: {{ userService.subDetails?.subscription?.subscription_levels_id == 1 ? ("account.monthly_plan" | translate) : ("account.annual_plan" | translate) }}
        </span>
      }
      @if (userService.subDetails.stripe_subscription && userService.subDetails.stripe_subscription.coupon && userService.subDetails.stripe_subscription.coupon == "SPHERE4MFREE") {
        <p class="c-green">
          {{ "account.four_months_free" | translate }}
        </p>
      }
      @if (userService.subDetails.stripe_subscription && userService.subDetails.stripe_subscription.coupon && userService.subDetails.stripe_subscription.coupon == "SPHERE1YFREE") {
        <p class="c-green">
          {{ "account.one_year_free" | translate }}
        </p>
      }
      @if (userService.subDetails.stripe_subscription && userService.subDetails.stripe_subscription.coupon && userService.subDetails.stripe_subscription.coupon == "SPHEREBF2020") {
        <p class="c-green">
          {{ "account.ten_percent_off" | translate }}
        </p>
      }

      <!-- <ng-container *ngIf="userService.subDetails.subscription">{{ "sphere.account.status" | translate }}: {{ statusMap[userService.subDetails.subscription.status].title }}</ng-container> -->
      @if ((!userService.subDetails.subscription || !userService.subDetails.active) && !loading) {
        <div class="brandfont-bold m-t-20">
          {{ "sphere.account.current_free_account" | translate }}
          <div class="m-y-20">
            <span [innerHTML]="'sphere.account.upgrade_description' | translate"></span>
          </div>
          <div class="m-b-20">
            <span class="brandfont-black">
              {{ "sphere.subscription_details.only_price" | translate: { monthly: userService.spherePrices.monthly, annual: userService.spherePrices.annual } }}
            </span>
          </div>
          <button class="btn btn-primary" (click)="upgrade()">{{ "sphere.subscription_details.upgrade_to_sphere" | translate }}</button>
        </div>
      }
      @if (
        userService.subDetails.active &&
        userService.subDetails.subscription &&
        !userService.subDetails.subscription.bundle_time &&
        !userService.subDetails.stripe_subscription &&
        !userService.subDetails.recharge_subscription &&
        !loading &&
        !userService.subDetails.scheduled_stripe_subscription
      ) {
        <div class="brandfont-bold">
          {{ "account.subscription_ends_on" | translate: { subscription_end_date: (userService.subDetails.subscription.end_date | date: "MMMM Do, YYYY") } }}
          <br />
          <br />
          @if (env.features.recharge) {
            <button class="btn btn-primary m-t-20" (click)="rechargePaymentOptions()">
              {{ "account.enter_payment_details" | translate }}
            </button>
          }
          @if (!env.features.recharge) {
            <button class="btn btn-primary m-t-20" (click)="setupSchedule()">
              {{ "account.enter_payment_details" | translate }}
            </button>
          }
        </div>
      }
      @if (userService.subDetails?.subscription?.subscription_levels_id == 2 && !hybridElligible) {
        <div>
          {{ "account.studio_one_pro_license_eligibility" | translate: { renewal_date: (userService.subDetails?.subscription?.end_date | date: "MMMM Do, YYYY") } }}
        </div>
      }
      @if (hybridElligible) {
        <div>
          {{ "account.studio_one_pro_license_included" | translate: { brand_name: env.studioOnePlusBrandName } }}
        </div>
      }

      <!-- =============START OF BUNDLE DESCRIPTORS============= -->
      @if (userService.subDetails?.subscription?.bundle_time) {
        @if (userService.subDetails?.subscription_status == "monthly_no_schedule") {
          <div class="m-t-20">
            <!-- They have an active 6 months monthly bundle subscription with no scheduled stripe subscription. -->
            <!-- You can maintain uninterrupted access to all the extras in Studio One Pro+ by subscribing to an Annual plan at any time before September 13th, 2025. You will not be charged until September 13th, 2025. -->
            <p>
              {{ "account.subscription_renewal_message" | translate: { brand_name: env.studioOnePlusBrandName, renewal_date: (userService.subDetails.subscription.end_date | date: "MMMM Do, YYYY") } }}
            </p>
            @if (env.features.recharge) {
              <button class="btn btn-primary m-t-20" (click)="rechargePaymentOptions()">
                {{ "account.enter_payment_details" | translate }}
              </button>
            }
            @if (!env.features.recharge) {
              <button class="btn btn-primary m-t-20" (click)="setupSchedule()">
                {{ "account.enter_payment_details" | translate }}
              </button>
            }
          </div>
        }
        @if (userService.subDetails?.subscription_status == "yearly_no_schedule") {
          <div class="m-t-20">
            <!-- They have an active 12 months hybrid bundle subscription with no scheduled stripe subscription. -->
            <p class="t-16">
              {{
                "account.maintain_access_message"
                  | translate
                    : {
                        renewal_date: (userService.subDetails.subscription.end_date | date: "MMMM Do, YYYY"),
                        next_payment_date: (userService.subDetails?.subscription.end_date | date: "MMMM Do, YYYY"),
                      }
              }}
            </p>
            @if (env.features.recharge) {
              <button class="btn btn-primary m-t-20" (click)="rechargePaymentOptions()">
                {{ "account.enter_payment_details" | translate }}
              </button>
            }
            @if (!env.features.recharge) {
              <button class="btn btn-primary m-t-20" (click)="setupSchedule()">
                {{ "account.enter_payment_details" | translate }}
              </button>
            }
          </div>
        }
        @if (userService.subDetails?.subscription_status == "monthly_scheduled") {
          <div class="m-t-20">
            <p>
              {{ "account.continue_access_message" }}
            </p>
            <button class="btn btn-primary m-t-20 btn-sm" (click)="setupSchedule()">{{ "account.upgrade_to_annual" | translate }}</button>
            <br />
            <br />
            <button class="btn btn-primary m-t-20 btn-sm" (click)="cancelSubscription()">{{ "account.cancel_scheduled_subscription" | translate }}</button>
          </div>
        }
        @if (userService.subDetails?.subscription_status == "yearly_scheduled") {
          <div class="m-t-20">
            <p>
              {{
                "account.continue_access_annual_plan"
                  | translate
                    : {
                        amount_due: isNoDecimalCurrency(userService.subDetails.upcoming_invoice_preview.currency)
                          ? isDivisibleBy100(userService.subDetails.upcoming_invoice_preview.currency)
                            ? (userService.subDetails.upcoming_invoice_preview.amount_due / 100 | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase())
                            : (userService.subDetails.upcoming_invoice_preview.amount_due | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase())
                          : (userService.subDetails.upcoming_invoice_preview.amount_due / 100 | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase() : "symbol" : "1.2-2"),
                        next_payment_date: (userService.subDetails?.upcoming_invoice_preview.next_payment_attempt * 1000 | date: "MMMM Do, YYYY"),
                      }
              }}
            </p>
            <button class="btn btn-primary m-t-20 btn-sm" (click)="cancelSubscription()">{{ "account.cancel_scheduled_subscription" | translate }}</button>
          </div>
        }
        @if (userService.subDetails?.subscription_status == "monthly_active_coupon") {
          <div class="m-t-20">
            {{
              "account.monthly_plan_will_return_to_regular_payments"
                | translate
                  : {
                      amount: isNoDecimalCurrency(userService.subDetails.upcoming_invoice_preview.currency)
                        ? isDivisibleBy100(userService.subDetails.upcoming_invoice_preview.currency)
                          ? (userService.subDetails.upcoming_invoice_preview.subtotal / 100 | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase())
                          : (userService.subDetails.upcoming_invoice_preview.subtotal | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase())
                        : (userService.subDetails.upcoming_invoice_preview.subtotal / 100 | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase()),
                      realDiscountEnd: (realDiscountEnd | date: "MMMM Do, YYYY"),
                    }
            }}
            <br />
            <br />
            <button class="btn btn-primary m-t-20 btn-sm" (click)="cancelSubscription()">{{ "account.cancel_scheduled_subscription" | translate }}</button>
          </div>
        }
        @if (userService.subDetails?.subscription_status == "yearly_active_coupon") {
          <div class="m-t-20">
            {{
              "account.yearly_plan_with_discount_renewal"
                | translate
                  : {
                      subscriptionEndDate: (userService.subDetails.subscription.end_date | date: "MMMM Do, YYYY"),
                    }
            }}
            <br />
            <br />
            <button class="btn btn-primary m-t-20 btn-sm" (click)="cancelSubscription()">{{ "account.cancel_scheduled_subscription" | translate }}</button>
          </div>
        }
        <!-- <div
          *ngIf="
            (!userService.subDetails.stripe_subscription && userService.subDetails.subscription.bundle_time && userService.subDetails.subscription.bundle_time > 0) ||
            (userService.subDetails.subscription_status == 'monthly_active_coupon' &&
              userService.subDetails.stripe_subscription.discount.start &&
              userService.subDetails.stripe_subscription.discount.end)
          "
> -->
      }
      @if (gettingLicenseDetails) {
        <div>
          <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
          {{ "account.loading_subscription_info" | translate }}
        </div>
      }
      @if (userService.subDetails?.subscription?.subscription_levels_id == 2 && (subscriptionProduct?.fallbackVersion || activeStudioOneVersion)) {
        <div>
          <div class="m-t-30">
            <fui-heading [text]="'account.perpetual_license_version' | translate" [level]="5"></fui-heading>
          </div>
          <span class="brandfont-black d-block m-t-20">{{ subscriptionProduct?.fallbackVersion || activeStudioOneVersion }}</span>
          <br />
          @if (!subscriptionProduct?.fallbackVersion) {
            <span>
              {{ "account.most_current_version" | translate }}
            </span>
          }
          @if (subscriptionProduct?.fallbackVersion) {
            <span>
              {{ "account.perpetual_license_info" | translate }}
            </span>
          }
        </div>
      }
      @if (userService.subDetails.active) {
        <div class="m-t-50">
          <fui-heading [text]="'account.remaining_time' | translate" [level]="5"></fui-heading>
          <div class="m-t-20">
            <myp-subscription-time-meter></myp-subscription-time-meter>
          </div>
        </div>
      }

      <!-- =============END OF BUNDLE DESCRIPTORS============= -->

      @if (showReactivateButton) {
        <div class="m-t-20">
          <span
            [translate]="'sphere.account.sub_ends_on_base'"
            [translateParams]="{
              date: (userService.subDetails.subscription.current_period_end * 1000 | date),
            }"
          ></span>
          <br />
          <button class="btn btn-primary btn-sm m-t-20" (click)="reactivate()">
            {{ "sphere.account.reactivate_membership" | translate }}
          </button>
        </div>
      }

      @if (userService.subDetails.subscription.status == "missed payment") {
        <div class="m-t-10">
          <myp-missed-payment-notice [missedPaymentDetails]="missedPaymentDetails"></myp-missed-payment-notice>
        </div>
      }
    </div>

    <div>
      <myp-inline-loader [loading]="loading" height="400px" spinnerName="loadingPlan"></myp-inline-loader>
      @if (noSubscriptionFound) {
        <div class="m-t-100 text-center">
          <fui-heading [text]="'sphere.account.sub_info_not_found' | translate" [level]="5"></fui-heading>
        </div>
      }

      @if (subscriptionProduct && subscriptionProduct.activations && subscriptionProduct.activations.length) {
        <div class="m-t-50">
          <fui-heading [text]="'sphere.account.sphere_activations' | translate" [level]="5"></fui-heading>
          @for (act of subscriptionProduct.activations; track act) {
            <myp-list-item [showImage]="false" [includeChevron]="false" [hoverState]="false" [includeBottomBorder]="true" [title]="act.comment" [subData]="[act.aquired | date]">
              <div class="button-content">
                <button class="action no-border no-background" ngbTooltip="Remove" [disabled]="loading" (click)="deactivate(act)">
                  @if (!act.loading) {
                    <fa-icon icon="times"></fa-icon>
                  } @else {
                    <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                  }
                </button>
              </div>
              <!-- <div class="button-content">
                @if (method.id == defaultCard?.id) {
                  <span class="brandfont-black text-nowrap" tabindex="0">Active</span>
                }
                @if (userService.subDetails?.subscription?.provider_subscription_id && method.id != defaultCard?.id && !paymentMethodLineItemLoaders[method.id]) {
                  <button class="action m-r-5 no-border no-background" ngbTooltip="Make Default" (click)="setCardAsDefault(method.id)">
                    <fa-icon icon="check"></fa-icon>
                    <span class="sr-only">Make Default</span>
                  </button>
                }
                @if (paymentMethodLineItemLoaders[method.id]) {
                  <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                }
                @if (method.id != defaultCard?.id && !paymentMethodLineItemLoaders[method.id]) {
                  <button class="action m-r-5 no-border no-background" ngbTooltip="Delete Payment Method" (click)="deletePaymentMethod(method.id)">
                    <fa-icon icon="times"></fa-icon>
                    <span class="sr-only">Delete Payment Method</span>
                  </button>
                }
              </div> -->
            </myp-list-item>

            <!-- <div class="manage-activations">
              <span>{{ act.comment }}</span>
              hi
              <div>
                <span class="d-inline-block m-r-10">{{ act.aquired | date }}</span>
                <button class="btn btn-danger btn-sm" [disabled]="loading" (click)="deactivate(act)">
                  @if (!act.loading) {
                    <span>{{ "general.remove" | translate }}</span>
                  }
                  @if (act.loading) {
                    <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                  }
                </button>
              </div>
            </div> -->
          }
        </div>
      }

      @if (subscriptionProduct && subscriptionProduct.mixerActivations && subscriptionProduct.mixerActivations.length) {
        <div class="m-t-50">
          <fui-heading [text]="'sphere.account.mixer_activations' | translate" [level]="5"></fui-heading>
          @for (act of subscriptionProduct.mixerActivations; track act) {
            <div class="manage-activations">
              <span>{{ act.comment }}</span>
              <span>{{ act.aquired | date }}</span>
              <button class="btn btn-danger btn-sm" [disabled]="loading" (click)="deactivate(act, true)">
                @if (!act.loading) {
                  <span>{{ "general.remove" | translate }}</span>
                }
                @if (act.loading) {
                  <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                }
              </button>
            </div>
          }
        </div>
      }

      @if (userService.subDetails && userService.subDetails.xchange_subscription) {
        <div class="m-t-50">
          <fui-heading [text]="'account.billing_details' | translate" [level]="5"></fui-heading>
          <div class="m-y-20">
            <div class="text-center">
              <p class="text-center">{{ "sphere.account.membership_title" | translate }}</p>
              <span class="brandfont-bold">{{ "sphere.account.sub_managed_third_party" | translate }}</span>
            </div>
            <div class="m-t-30 m-b-50 plan-detail-section">
              <div class="d-flex align-items-center">
                <div class="w-full t-14 bold c-gray flex-wrap m-x-5 m-y-5 text-right">{{ "sphere.account.managed_by" | translate }}</div>
                |
                <div class="w-full t-14 flex-wrap m-x-5 m-y-5 text-left">{{ userService.subDetails.xchange_subscription.Reseller_Name }}</div>
              </div>
              <div class="d-flex align-items-center">
                <div class="w-full t-14 bold c-gray flex-wrap m-x-5 m-y-5 text-right">{{ "sphere.account.start_date" | translate }}</div>
                |
                <div class="w-full t-14 flex-wrap m-x-5 m-y-5 text-left">{{ userService.subDetails.xchange_subscription.Start_Date.split("+")[0] | date }}</div>
              </div>
              <div class="d-flex align-items-center">
                <div class="w-full t-14 bold c-gray flex-wrap m-x-5 m-y-5 text-right">{{ "account.next_invoice_date" | translate }}</div>
                |
                <div class="w-full t-14 flex-wrap m-x-5 m-y-5 text-left">{{ userService.subDetails.xchange_subscription.Next_Bill_Date.split("+")[0] | date }}</div>
              </div>
            </div>
          </div>
          <div class="text-center">
            {{ "sphere.account.to_make_changes" | translate }}
          </div>
        </div>
      }

      @if (!loading && userService.subDetails?.upcoming_invoice_preview) {
        <div class="m-t-50">
          <fui-heading [text]="'account.your_next_invoice' | translate" [level]="5"></fui-heading>
          <div class="row m-t-20">
            <div class="col-4 col-lg-3">{{ "account.payment_date" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ userService.subDetails.upcoming_invoice_preview.next_payment_attempt * 1000 | date: "MMM Do, YYYY" }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            <div class="col-4 col-lg-3">{{ "account.subtotal" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{
                isNoDecimalCurrency(userService.subDetails.upcoming_invoice_preview.currency)
                  ? isDivisibleBy100(userService.subDetails.upcoming_invoice_preview.currency)
                    ? (userService.subDetails.upcoming_invoice_preview.subtotal / 100 | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase())
                    : (userService.subDetails.upcoming_invoice_preview.subtotal | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase())
                  : (userService.subDetails.upcoming_invoice_preview.subtotal / 100 | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase() : "symbol" : "1.2-2")
              }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            @if (userService.subDetails.upcoming_invoice_preview.discount && userService.subDetails.upcoming_invoice_preview.discount.coupon?.percent_off) {
              <div class="col-4 col-lg-3">{{ "account.coupon_applied" | translate }}</div>
              <div class="col-8 col-lg-9 c-green">{{ userService.subDetails.upcoming_invoice_preview.discount.coupon.percent_off }}% Off</div>
              <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            }
            <div class="col-4 col-lg-3">{{ "account.total" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{
                (isNoDecimalCurrency(userService.subDetails.upcoming_invoice_preview.currency)
                  ? isDivisibleBy100(userService.subDetails.upcoming_invoice_preview.currency)
                    ? (userService.subDetails.upcoming_invoice_preview.amount_due / 100 | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase())
                    : (userService.subDetails.upcoming_invoice_preview.amount_due | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase())
                  : (userService.subDetails.upcoming_invoice_preview.amount_due / 100 | currency: userService.subDetails.upcoming_invoice_preview.currency.toUpperCase() : "symbol" : "1.2-2")) +
                  " " +
                  (userService.subDetails.upcoming_invoice_preview.amount_due > 0 ? (isTaxIncluded ? "including tax" : "excluding tax") : "")
              }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
          </div>
        </div>
      }

      @if (!loading && userService.subDetails?.stripe_subscription?.product && statusMap[userService.subDetails?.subscription.status].title != "Canceled") {
        <div class="m-t-50">
          <fui-heading [text]="'account.payment_details' | translate" [level]="5"></fui-heading>
          <div class="m-t-20">
            <div class="row">
              <div class="col-4 col-lg-3">{{ "account.billing_frequency" | translate }}</div>
              <div class="col-8 col-lg-9">
                {{ userService.subDetails.stripe_subscription.product.price.recurring["interval"] == "month" ? "Monthly" : "Annual" }}
                @if (statusMap[userService.subDetails.stripe_subscription.status].title != "Canceled" && userService.subDetails.stripe_subscription.product.price.recurring["interval"] !== "year") {
                  <button class="btn btn-secondary btn-sm m-l-10" (click)="previewSwitchPlanPrice()">Switch to {{ env.features.hybrid_plan_messaging ? "Hybrid" : "Annual" }} Plan</button>
                }
              </div>
              <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
              <div class="col-4 col-lg-3">
                {{ "sphere.account.recurring_amt" | translate }}
              </div>
              <div class="col-8 col-lg-9">
                {{
                  (isNoDecimalCurrency(userService.subDetails.stripe_subscription.product.price["currency"])
                    ? isDivisibleBy100(userService.subDetails.stripe_subscription.product.price["currency"])
                      ? (userService.subDetails.stripe_subscription.product.price["unit_amount"] / 100 | currency: userService.subDetails.stripe_subscription.product.price["currency"].toUpperCase())
                      : (userService.subDetails.stripe_subscription.product.price["unit_amount"] | currency: userService.subDetails.stripe_subscription.product.price["currency"].toUpperCase())
                    : (userService.subDetails.stripe_subscription.product.price["unit_amount"] / 100
                      | currency: userService.subDetails.stripe_subscription.product.price["currency"].toUpperCase() : "symbol" : "1.2-2")) +
                    " " +
                    (isTaxIncluded ? "including tax" : "excluding tax")
                }}
              </div>
              <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
              @if (userService.subDetails.stripe_subscription && defaultCard) {
                <div class="col-4 col-lg-3">{{ "account.payment_method" | translate }}</div>
                <div class="col-8 col-lg-9">
                  <img
                    alt="{{ defaultCard.card.brand }} card"
                    src="{{ checkoutService.cardBrandIcons[defaultCard.card.brand] || checkoutService.cardBrandIcons['generic'] }}"
                    style="width: 24px; margin-right: 10px"
                  />
                  {{ "account.ending_in" | translate: { lastFour: defaultCard.card.last4 } }}&nbsp;&nbsp;&nbsp;
                </div>
                <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
              }
              @if (userService.subDetails.stripe_subscription.status && statusMap[userService.subDetails.stripe_subscription.status].title != "Canceled") {
                <div class="col-4 col-lg-3">
                  {{ "sphere.account.next_charge_date" | translate }}
                </div>
                <div class="col-8 col-lg-9">
                  {{ userService.subDetails.next_charge_date | date: "MMM Do, YYYY" }}
                </div>
                <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
                <div class="col-4 col-lg-3">
                  {{ "sphere.account.auto_renew" | translate }}
                </div>
                <div class="col-8 col-lg-9">
                  <span class="brandfont-black">{{ userService.subDetails.stripe_subscription.collection_method !== "charge_automatically" ? "OFF" : "ON" }}</span>
                </div>
                <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
              }
            </div>
          </div>
        </div>
      }

      @if (!loading) {
        <div class="m-t-50">
          <fui-heading [text]="'account.payment_methods' | translate" [level]="5"></fui-heading>
          @if (this.userService.paymentMethods && this.userService.paymentMethods.length) {
            @for (method of this.userService.paymentMethods; track method) {
              <myp-list-item
                [photo]="checkoutService.cardBrandIcons[method.card.brand] || checkoutService.cardBrandIcons.generic"
                [photoAlt]="method.card.brand + ' card'"
                [imageRound]="false"
                [imageBorder]="false"
                [includeChevron]="false"
                [hoverState]="false"
                [includeBottomBorder]="true"
                [title]="'Ending in ' + method.card.last4"
                [subData]="['Expires ' + method.card.exp_month + '/' + method.card.exp_year]"
              >
                <div class="button-content">
                  @if (method.id == defaultCard?.id) {
                    <span class="brandfont-black text-nowrap" tabindex="0">Active</span>
                  }
                  @if (userService.subDetails?.subscription?.provider_subscription_id && method.id != defaultCard?.id && !paymentMethodLineItemLoaders[method.id]) {
                    <button class="action m-r-5 no-border no-background" ngbTooltip="Make Default" (click)="setCardAsDefault(method.id)">
                      <fa-icon icon="check"></fa-icon>
                      <span class="sr-only">Make Default</span>
                    </button>
                  }
                  @if (paymentMethodLineItemLoaders[method.id]) {
                    <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                  }
                  @if (method.id != defaultCard?.id && !paymentMethodLineItemLoaders[method.id]) {
                    <button class="action m-r-5 no-border no-background" ngbTooltip="Delete Payment Method" (click)="deletePaymentMethod(method.id)">
                      <fa-icon icon="times"></fa-icon>
                      <span class="sr-only">Delete Payment Method</span>
                    </button>
                  }
                </div>
              </myp-list-item>
            }
          }
          @if (!this.userService.paymentMethods || !this.userService.paymentMethods.length) {
            <p>{{ "account.no_payment_methods" | translate }}</p>
          }
          <button class="brand-btn-reverse sm m-t-20" (click)="goToAddPaymentMethod()">Create New Payment Method</button>
        </div>
      }

      @if (!loading && userService.subDetails?.payment_history?.length) {
        <div class="m-t-50">
          <fui-heading [text]="'sphere.account.payment_history' | translate" [level]="5"></fui-heading>
          <div class="row m-t-20">
            @for (pay of userService.subDetails.payment_history; track pay) {
              <div class="col-4 col-lg-3">
                {{ pay.created * 1000 | date: "MMM Do, YYYY" }}
              </div>
              <div class="col-8 col-lg-9">
                <div class="d-flex justify-content-between">
                  <div>
                    <fa-icon [icon]="pay.status == 'open' ? 'warning' : 'check-circle'" [class.c-orange]="pay.status == 'open'" [class.c-green]="pay.status == 'paid'"></fa-icon>
                    <strong>
                      {{
                        pay.total
                          ? isNoDecimalCurrency(pay.currency)
                            ? isDivisibleBy100(pay.currency)
                              ? (pay.total / 100 | currency: pay.currency.toUpperCase())
                              : ((pay.total / 100) * 100 | currency: pay.currency.toUpperCase())
                            : (pay.total / 100 | currency: pay.currency.toUpperCase() : "symbol" : "1.2-2")
                          : "$0.00 - "
                      }}
                    </strong>
                    {{ pay.billing_reason == "subscription_cycle" ? "Subscription Payment" : (pay.billing_reason.replace("_", " ") | titlecase) }}
                    @if (pay.next_payment_attempt) {
                      <div class="t-12">
                        This payment failed. We have attempted to charge this payment {{ pay.attempt_count }} {{ pay.attempt_count > 1 ? "times" : "time" }}. We will attempt to charge your Active
                        payment method again on {{ { _seconds: pay.next_payment_attempt } | date }}.
                      </div>
                    }
                  </div>
                  @if (pay.invoice_pdf) {
                    <div>
                      <a class="small-btn text-nowrap" [href]="pay.invoice_pdf" target="_blank">
                        <fa-icon icon="external-link"></fa-icon>
                        &nbsp; {{ "account.view_invoice" | translate }}
                      </a>
                    </div>
                  }
                </div>
              </div>
              <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            }
          </div>
        </div>
      }

      @if (userService.storageDetails && userService.subDetails && userService.subDetails.active) {
        <div class="m-t-50">
          <fui-heading [text]="'account.storage_details' | translate: { storage_gigabytes_included: userService.subDetails.subscription.storage_gigabytes_included }" [level]="5"></fui-heading>
          <div class="m-t-20">
            <myp-storage-meter></myp-storage-meter>
          </div>
        </div>
      }

      @if (!loading) {
        <div class="m-b-20 m-t-50">
          @if (showCancelButton && !showReactivateButton) {
            <button class="small-btn" (click)="cancelSubscription()">
              {{ "sphere.account.cancel_membership" | translate }}
            </button>
          }
          <br />
          <br />
          <a href="https://www.presonus.com/privacy-policy" target="_blank" class="tiny-link">
            {{ "account.privacy_policy_link" | translate }}
          </a>
          &nbsp;|&nbsp;
          <a href="https://www.presonus.com/eula" target="_blank" class="tiny-link">EULA</a>
        </div>
      }
    </div>
  </div>
  <ngx-spinner type="line-scale-pulse-out"></ngx-spinner>
</div>

<ng-template #rechargeConfirmAddPaymentModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-password-update">Add Payment Method</h4>
    <button ngbAutofocus class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    You are about to be redirected to a secure payment page to add a new payment method. It will list a $0 charge to verify the card. Once added, your card will be charged on
    {{ userService.subDetails.subscription.end_date | date: "M/D/y" }}.
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click)="setupSchedule(); modal.close()">Continue</button>
    @if (userService.subDetails?.subscription?.subscription_levels_id == 1) {
      <button type="submit" class="btn btn-primary" (click)="setupSchedule(true); modal.close()">Upgrade to Annual for $99</button>
    }
  </div>
</ng-template>
